/** * 错误日志详情 */
<template>
	<lcsj-dialog v-model="showVisible" :title="title" width="70%" @close="closeDialog" cancel-text="" confirm-text="">
		<div v-loading="loading">
			<el-descriptions :column="2" border size="medium">
				<el-descriptions-item label="时间">{{ info.createDate }}</el-descriptions-item>
				<el-descriptions-item label="操作人">{{ info.operatorName || '--' }}</el-descriptions-item>
				<el-descriptions-item label="模块" :span="2">{{ info.apiModule || '--' }}</el-descriptions-item>
				<el-descriptions-item label="主要信息" :span="2">
					<span class="err-title">{{ info.title || '--' }}</span>
				</el-descriptions-item>
				<el-descriptions-item label="异常类型" :span="2">{{ info.exceptionType || '--' }}</el-descriptions-item>
				<el-descriptions-item label="调用方法" :span="2">{{ info.requestMethod || '--' }}</el-descriptions-item>
				<el-descriptions-item label="方法位置" :span="2">{{ info.methodLocation || '--' }}</el-descriptions-item>
				<el-descriptions-item label="请求地址" :span="2">{{ info.url || '--' }}</el-descriptions-item>
			</el-descriptions>
			<div class="block-title">请求参数</div>
			<el-input type="textarea" :value="info.params || '无'" readonly :autosize="{ minRows: 2, maxRows: 8 }"></el-input>
			<div class="block-title">堆栈信息</div>
			<pre class="stack-pre">{{ info.stackTrace || '无' }}</pre>
		</div>
		<span slot="footer">
			<el-button @click="closeDialog" size="small" icon="el-icon-close">关闭</el-button>
		</span>
	</lcsj-dialog>
</template>

<script>
import { GetSystemErrorLogByKeyId } from "@/api/systemErrorLogApi.js";

export default {
	data() {
		return {
			title: "错误日志详情",
			showVisible: false,
			loading: false,
			info: {},
		};
	},
	methods: {
		showDetail(keyId) {
			this.showVisible = true;
			this.loading = true;
			this.info = {};
			GetSystemErrorLogByKeyId({ keyId: keyId })
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.info = res.data || {};
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("加载详情失败！");
				});
		},
		closeDialog() {
			this.showVisible = false;
		},
	},
};
</script>

<style scoped>
.err-title {
	color: var(--app-danger);
	font-weight: bold;
}
.block-title {
	margin: 16px 0 8px;
	font-weight: bold;
	font-size: 14px;
	color: var(--app-text);
}
.stack-pre {
	background: var(--app-surface-muted);
	border: 1px solid var(--app-border-strong);
	border-radius: 4px;
	padding: 12px;
	font-family: Consolas, Monaco, monospace;
	font-size: 12px;
	color: var(--app-danger);
	white-space: pre-wrap;
	word-break: break-all;
	max-height: 360px;
	overflow-y: auto;
	margin: 0;
}
</style>
